import { createFileRoute } from '@tanstack/react-router';

import { WeatherPageView } from '@/components/site/pages';
import { seoHead } from '@/lib/seo';
import { loadWeatherPage } from '@/server/functions/pages';

export const Route = createFileRoute('/weather')({
    loader: () => loadWeatherPage(),
    head: () =>
        seoHead({
            title: 'מזג האוויר באשקלון',
            description:
                'תחזית מזג האוויר באשקלון היום, מצב הים בחוף הדרום, וערים נוספות מהשירות המטאורולוגי.',
            path: '/weather',
            keywords: 'מזג האוויר אשקלון, תחזית אשקלון, מצב הים אשקלון',
        }),
    component: WeatherPage,
});

function WeatherPage() {
    const data = Route.useLoaderData();
    return <WeatherPageView {...data} />;
}
